module.exports = __webpack_public_path__ + "a265c73f61f646d7863ee7cfcf8ac23c.pdf";